import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Sticky from 'react-stickynode';
import get from 'lodash/get';
import assign from 'lodash/assign';
import Ad from '../../ad/ad';
import RelatedPosts from '../../related_posts/related_posts';
import { imageSizesLookup } from '../../../../utils/cloudinary_asset_util';

export default class PostSidebar extends Component {
  calculateAds(article) {
    if (!article) {
      return 1;
    }
    const AVERAGE_P_TAG_HEIGHT = 175;
    const AVERAGE_FIGURE_TAG_HEIGHT = 485;
    const AVERAGE_DISTANCE_INBETWEEN_ADS = 1400;
    const MIN_ADS = 1;
    const MAX_ADS = 12;

    const ps = (article.match(/<p/g) || []).length;
    const figures = (article.match(/<figure/g) || []).length;
    const height =
      ps * AVERAGE_P_TAG_HEIGHT + figures * AVERAGE_FIGURE_TAG_HEIGHT;
    let totalAds = Math.round(height / AVERAGE_DISTANCE_INBETWEEN_ADS);

    if (!totalAds) {
      totalAds = MIN_ADS;
    } else if (totalAds > MAX_ADS) {
      totalAds = MAX_ADS;
    }

    return totalAds;
  }

  renderSidebar() {
    const {
      post,
      postExtras,
      related,
      combinedAdModel,
      isDesktop,
      site,
      relatedHeight,
      fullPageAdvertorial,
      totalAdCount
    } = this.props;
    const totalAds = totalAdCount;
    const relatedStyles = relatedHeight
      ? { marginBottom: `${relatedHeight + 100}px` }
      : null;
    const ads = [];

    for (let i = 0; i < totalAds; i += 1) {
      ads.push(
        <div
          key={i}
          className="post__promotion"
          id={`post-ad-${post.id}-${i}`}
          style={i === 0 ? relatedStyles : null}
        >
          {/* eslint-disable no-nested-ternary */}
          <Sticky
            top={100}
            bottomBoundary={`#post-ad-${post.id}-${i}`}
            enabled={isDesktop || false}
          >
            <Ad
              {...combinedAdModel}
              noLazyLoad={i === 0 && postExtras}
              pos={i === 0 ? 'atf' : 'btf'}
              name={
                i === 0 && get(this.props, 'post.posterSlideshow')
                  ? 'slideshowhalfpage'
                  : i === 0 ? 'flexibleportrait' : `flexiblehalfpage_${i}`
              }
              canRefresh={!!get(this.props, 'post.posterSlideshow')}
              pageNum={get(this.props, 'pageNum')}
            />
            {i === 0
              ? <div className="post__relative">
                  <RelatedPosts
                    stories={related.map(article =>
                      assign(article, {
                        currentSite: site,
                        assetSizes: imageSizesLookup.column
                      })
                    )}
                    fullPageAdvertorial={fullPageAdvertorial}
                  />
                </div>
              : null}
          </Sticky>
          {/* eslint-enable no-nested-ternary */}
        </div>
      );
    }

    return ads;
  }

  render() {
    if (!this.props) {
      return null;
    }

    return (
      <div className="post__sidebar">
        {this.renderSidebar()}
      </div>
    );
  }
}

PostSidebar.defaultProps = {
  related: [],
  isDesktop: false,
  relatedHeight: 0,
  fullPageAdvertorial: false,
  totalAdCount: 2
};

PostSidebar.propTypes = {
  post: PropTypes.shape({}).isRequired,
  postExtras: PropTypes.bool.isRequired,
  related: PropTypes.arrayOf(PropTypes.shape({})),
  combinedAdModel: PropTypes.shape({}).isRequired,
  isDesktop: PropTypes.bool,
  site: PropTypes.string.isRequired,
  relatedHeight: PropTypes.number,
  fullPageAdvertorial: PropTypes.bool,
  totalAdCount: PropTypes.number
};



// WEBPACK FOOTER //
// ./src/views/components/post/sidebar/post_sidebar.js